import { ClientType } from '@common/model/client/clientType';
import { CLIENT_TYPE_TRANSLATIONS } from '@common/const/resource/client';

export const clientTypeToEventParam = (type?: ClientType) => {
  if (type) {
    return { 'Тип пользователя': CLIENT_TYPE_TRANSLATIONS[type] };
  }
};
